"use client";

import { TProductRequirementSection } from "@shared/types";
import { ProductRequirementItems, SectionHeading } from "@shared/ui";

export function ProductRequirementSection({ title, items }: TProductRequirementSection) {
  return (
    <section className="py-20 sm:py-[100px] relative">
      <div className="container relative">
        <div className="flex gap-10 sm:gap-[60px] lg:gap-20 w-full flex-col lg:flex-row">
          <div className="lg:w-[45%] lg:min-w-[45%]">
            <SectionHeading title={title} />
          </div>

          <div className="border-gray-200">{items && items?.length > 0 && <ProductRequirementItems items={items} />}</div>
        </div>
      </div>
    </section>
  );
}
